module.exports = __webpack_public_path__ + "dimsans-webfont.220a9345f69de1e727f7.woff2";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/assets/fonts/dimsans-webfont.woff2
// module id = ../../../../../src/assets/fonts/dimsans-webfont.woff2
// module chunks = styles